import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Forecast.css";
import { useNavigate, useLocation } from "react-router-dom";

const Forecast = () => {
  const { REACT_APP_DB, REACT_APP_PORT_BACK, REACT_APP_FROM } = process.env;

  const [employeeID, setEmployeeID] = useState("");
  const [employeeInfo, setEmployeeInfo] = useState(null);
  const [isSearching, setIsSearching] = useState(false);
  const [employeeSearchError, setEmployeeSearchError] = useState("");
  const [isEmployeeVerified, setIsEmployeeVerified] = useState(false);

  const [forecastList, setForecastList] = useState([]);
  const [selectedForecast, setSelectedForecast] = useState(null);
  const [status, setStatus] = useState("Confirmed");
  const [issueDetail, setIssueDetail] = useState("");
  const [attachment, setAttachment] = useState(null);

  // ⭐ เก็บว่า Forecast ไหน preview แล้ว
  const [previewedMap, setPreviewedMap] = useState({});
  const [previewUrl, setPreviewUrl] = useState(null);

  const location = useLocation();
  const username = location.state?.idvender;
  const fullname = location.state?.fullname || "Usffer";
  const userinuse = location.state?.userinuse;
  const wherefrm = location.state?.wherefrm;

  const [previewItem, setPreviewItem] = useState(null);
  console.log("username", username);
  console.log("fullname", fullname);
  console.log("userinuse", userinuse);

  const [selectedvenderid, setSelectedvenderid] = useState("");
  const [dataListVenderid, setListVenderid] = useState([]);

  const handleEmployeeSearch_ok = async (event) => {
    event.preventDefault();
    const employeeIDToSearch = employeeID.trim();
    if (!employeeIDToSearch) return;

    setIsSearching(true);
    setEmployeeInfo(null);
    setEmployeeSearchError("");

    try {
      const url =
        REACT_APP_FROM === "local"
          ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/employee/search`
          : `/api/employee/search`;
      const response = await axios.post(url, {
        employeeID: employeeIDToSearch,
      });
      if (response.data) {
        setEmployeeInfo(response.data);
      } else {
        setEmployeeSearchError("ไม่พบข้อมูลพนักงาน");
      }
    } catch (error) {
      console.error("Error searching employee:", error);
      setEmployeeSearchError(
        error.response?.data?.error || "ค้นหาข้อมูลพนักงานไม่สำเร็จ",
      );
    } finally {
      setIsSearching(false);
    }
  };
  const handleEmployeeSearch = async (event) => {
    event.preventDefault();

    if (!employeeID.trim()) return;

    try {
      setIsSearching(true);
      setEmployeeSearchError("");
      setEmployeeInfo(null);
      setIsEmployeeVerified(false);
      setForecastList([]);

      const url =
        REACT_APP_FROM === "local"
          ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/employee/search`
          : `/api/employee/search`;

      // เรียก API แบบ POST
      const response = await axios.post(url, {
        employeeID: employeeID.trim(),
      });

      if (response.data) {
        setEmployeeInfo(response.data);
        setIsEmployeeVerified(true);

        // ค้นหาสำเร็จ โหลด Forecast
        await fetchList(selectedvenderid, employeeID.trim());
      } else {
        setEmployeeSearchError("ไม่พบข้อมูลพนักงาน");
      }
    } catch (error) {
      console.error("Employee search error:", error);

      setEmployeeSearchError(
        error.response?.data?.error || "ไม่พบข้อมูลพนักงาน",
      );
    } finally {
      setIsSearching(false);
    }
  };
  const fetchList = async (venderid = null, empID = null) => {
    const userstr = venderid || username;

    try {
      const url =
        REACT_APP_FROM === "local"
          ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/forecast/listtestlocal`
          : `/api/forecast/listtestlocal`;

      const res = await axios.post(url, {
        userid: userstr.split("|")[0],
        wherefrm: wherefrm,

        // ส่งรหัสพนักงานเพิ่มเติม เฉพาะกรณี S1000
        employeeID: empID,
      });

      setForecastList(res.data);
    } catch (err) {
      console.error("Error loading list", err);
    }
  };

  useEffect(() => {
    if (fullname?.toLowerCase() === "matco") {
      if (!selectedvenderid) {
        setForecastList([]);
        return;
      }

      // ดึงเฉพาะ VenderID ก่อนเครื่องหมาย |
      const venderID = selectedvenderid.split("|")[0].trim();

      if (venderID === "S1000") {
        // ต้องค้นหารหัสพนักงานก่อน
        setForecastList([]);
        setIsEmployeeVerified(false);
        setEmployeeInfo(null);
        setEmployeeID("");
        return;
      }

      // Vender อื่น โหลด Forecast ได้ทันที
      setEmployeeID("");
      setEmployeeInfo(null);
      setIsEmployeeVerified(false);

      fetchList(selectedvenderid);
    } else {
      fetchList();
    }
  }, [selectedvenderid, fullname]);

  // const fetchList = async (venderid = null) => {
  //   console.log("fetchList:", selectedvenderid);

  //   const userstr = venderid || username; // ✅ ใช้บรรทัดนี้พอ
  //   console.log("userstr_", userstr.split("|")[0]);
  //   console.log("wherefrmtest_", wherefrm);
  //   try {
  //     const url =
  //       REACT_APP_FROM === "local"
  //         ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/forecast/listtestlocal`
  //         : `/api/forecast/listtestlocal`;

  //     const res = await axios.post(url, {
  //       userid: userstr.split("|")[0],
  //       wherefrm: wherefrm,
  //       // venderid: venderid, // 👈 ส่งเพิ่มไป
  //     });

  //     setForecastList(res.data);
  //   } catch (err) {
  //     console.error("Error loading list", err);
  //   }
  // };

  // useEffect(() => {
  //   if (fullname?.toLowerCase() === "matco") {
  //     // ถ้าเป็น matco ต้องเลือก vender ก่อน
  //     if (selectedvenderid) {
  //       fetchList(selectedvenderid);
  //     }
  //   } else {
  //     // supplier ปกติ โหลดเลย
  //     fetchList();
  //   }
  // }, [selectedvenderid, fullname]);
  // ------------------ SUBMIT ------------------
  // const { ForecastID, VendorCode, ResponseStatus, IssueDetail } = req.body;

  const handleSubmit = async () => {
    console.log("ForecastID", selectedForecast.ForecastID);
    try {
      const form = new FormData();
      form.append("ForecastID", selectedForecast.ForecastID);
      form.append("VendorCode", username);
      form.append("VendorName", fullname);
      form.append("ResponseStatus", status);
      form.append("IssueDetail", issueDetail);
      form.append("Userinuse", userinuse);
      if (attachment) form.append("Attachment", attachment);

      const url =
        REACT_APP_FROM === "local"
          ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/forecast/submitresponse`
          : `/api/forecast/submitresponse`;

      const res = await axios.post(url, form);
      console.log("datamail", res.data);

      if (res.data.dbSuccess && res.data.emailSuccess) {
        alert("บันทึกสำเร็จ และส่งอีเมลเรียบร้อย");

        //// ✅ reset เฉพาะกรณีสำเร็จ
        setSelectedForecast(null);
        setStatus("Confirmed");
        setIssueDetail("");
        setAttachment(null);

        await fetchList(); // refresh ตาราง
      } else if (res.data.dbSuccess && !res.data.emailSuccess) {
        alert(
          `❌ ส่ง e-mail ไม่สำเร็จ กรุณาติดต่อ IT Matco\n` +
            `พบ email ผิด:\n${res.data.invalidEmails.join("\n")}`,
        );
      } else {
        alert("ไม่สามารถบันทึกข้อมูลได้");
      }
    } catch (error) {
      console.error("errorsendmail_".error);
      alert("เกิดข้อผิดพลาด ไม่สามารถส่งข้อมูลได้");
    }
  };

  const [showResponseDialog, setShowResponseDialog] = useState(false);

  const [historyList, setHistoryList] = useState([]);
  const [showHistory, setShowHistory] = useState(false);
  const [historyItem, setHistoryItem] = useState(null);
  const loadHistory = async (forecast) => {
    try {
      const url =
        REACT_APP_FROM === "local"
          ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/forecast/response/history/${forecast.ForecastID}`
          : `/api/forecast/response/history/${forecast.ForecastID}`;

      const res = await axios.get(url);
      console.log("{ResponseID_}", res.data);
      setHistoryList(res.data);
      setHistoryItem(forecast);
      console.log("{forecast_}", forecast);
      setShowHistory(true);
    } catch (err) {
      console.error("load history error", err);
    }
  };

  // ดึงข้อมูล venderid จาก API
  useEffect(() => {
    const fetchvenderid = async () => {
      try {
        const url =
          REACT_APP_FROM === "local"
            ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/showidvender`
            : `/api/showidvender`;
        const response = await fetch(url);
        const data = await response.json();
        console.log(data + "_test");
        setListVenderid(data);
      } catch (error) {
        console.error("Error fetching buyers:", error);
      }
    };
    fetchvenderid();
  }, []);

  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <div className="forecast-container">
      <nav className="navbar">
        <td>
          <h1>Forecast Confirmation</h1>
          <h2>Supplier: {fullname}</h2>
        </td>
      </nav>
      {fullname?.toLowerCase() === "matco" && (
        <div style={{ margin: "15px 0" }}>
          <label style={{ marginRight: "10px" }}>Select venderID:</label>

          <input
            list="vender-name-list"
            value={selectedvenderid}
            onChange={(e) => setSelectedvenderid(e.target.value)}
            onFocus={() => setSelectedvenderid("")}
            placeholder="Type or select a venderid"
          />

          <datalist id="vender-name-list">
            {dataListVenderid.map((item, index) => (
              <option key={index} value={item.VenderID} />
            ))}
          </datalist>

          {/* แสดงช่องค้นหาเฉพาะ S1000 */}
          {selectedvenderid?.split("|")[0]?.trim() === "S1000" && (
            <form onSubmit={handleEmployeeSearch} style={{ marginTop: "12px" }}>
              <label style={{ marginRight: "10px" }}>รหัสพนักงาน:</label>

              <input
                type="text"
                value={employeeID}
                onChange={(e) => {
                  setEmployeeID(e.target.value);
                  setEmployeeInfo(null);
                  setEmployeeSearchError("");
                  setIsEmployeeVerified(false);
                }}
                placeholder="กรอกรหัสพนักงาน"
              />

              <button
                type="submit"
                disabled={!employeeID.trim() || isSearching}
                style={{ marginLeft: "8px" }}
              >
                {isSearching ? "กำลังค้นหา..." : "ค้นหา"}
              </button>

              {employeeInfo && (
                <p>
                  ผู้ดูแล: {employeeInfo.employeeName}({employeeInfo.employeeID}
                  )
                </p>
              )}

              {employeeSearchError && (
                <p style={{ color: "red" }}>{employeeSearchError}</p>
              )}
            </form>
          )}
        </div>
      )}
      <table className="forecast-table">
        <thead>
          <tr>
            <th>Issue Month</th>
            <th>Revision</th>
            <th>Download Attachment</th>
            <th>Supplier Confirmation</th>
            <th>Supplier Response</th>
            <th>Remark</th>
          </tr>
        </thead>
        <tbody>
          {forecastList.map((item) => (
            <tr key={item.ForecastID}>
              <td className="text-center">{item.YearMonth}</td>
              <td className="text-center">{item.ForcastRevise}</td>
              <td>
                <div style={{ display: "flex", gap: "8px" }}>
                  {/* ปุ่ม PDF */}
                  <button
                    className="preview-btn"
                    onClick={() => {
                      const url =
                        REACT_APP_FROM === "local"
                          ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/forecast-files/${item.FileName}`
                          : `/api/forecast-files/${item.FileName}`;

                      setPreviewUrl(url);
                      setPreviewItem(item);
                    }}
                  >
                    PDF
                  </button>

                  {/* ปุ่ม Excel */}
                  {item.Forcastexcelfile && (
                    <button
                      className="confirm-btn"
                      onClick={() => {
                        const excelUrl =
                          REACT_APP_FROM === "local"
                            ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/forecast-excel/${item.Forcastexcelfile}`
                            : `/api/forecast-excel/${item.Forcastexcelfile}`;

                        window.open(excelUrl, "_blank");
                      }}
                    >
                      Excel
                    </button>
                  )}
                </div>
              </td>
              <td>
                <div className="preview-actions">
                  <button
                    className="confirm-btn"
                    onClick={() => {
                      setPreviewItem(item);
                      setSelectedForecast(item);
                      setShowResponseDialog(true);
                      setPreviewUrl(null); // ปิด preview
                    }}
                  >
                    Confirmation
                  </button>
                </div>
              </td>
              <td className="text-center">
                <span
                  className={`status-badge ${
                    item.DisplayStatus === "Confirmed"
                      ? "status-success"
                      : item.DisplayStatus === "Has Issue"
                        ? "status-rejected"
                        : item.DisplayStatus === "Under Review"
                          ? "status-underreview"
                          : item.DisplayStatus === "Delay Confirmation"
                            ? "status-delay"
                            : "status-pending"
                  }`}
                >
                  {item.DisplayStatus === "Has Issue"
                    ? "Rejected"
                    : item.DisplayStatus}
                </span>
              </td>

              <td>
                <button
                  className="history-btn"
                  onClick={() => loadHistory(item)}
                >
                  Reply History
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {showHistory && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>HISTORY – {historyItem.YearMonth}</h2>

            <button className="close-btn" onClick={() => setShowHistory(false)}>
              X
            </button>

            {historyList.length === 0 ? (
              <p>There are not replies</p>
            ) : (
              historyList.map((h, idx) => (
                <div className="history-item" key={idx}>
                  <p>
                    <b>Status:</b> {h.ResponseStatus}
                  </p>
                  {h.IssueDetail && (
                    <p>
                      <b>Detail:</b> {h.IssueDetail}
                    </p>
                  )}
                  <p>
                    {/* <b>Date:</b>
                    {h.RespondedDate} */}
                    <b>Date:</b>{" "}
                    {h.RespondedDate?.replace("T", " ").replace("Z", "")}
                  </p>
                  {h.AttachmentPath &&
                    (() => {
                      const url =
                        REACT_APP_FROM === "local"
                          ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/forecast/attachmentload/${h.ResponseID}`
                          : `/api/forecast/attachmentload/${h.ResponseID}`;

                      return (
                        <a href={url} target="_blank" rel="noopener noreferrer">
                          ดาวน์โหลดไฟล์แนบ
                        </a>
                      );
                    })()}
                  {/* {h.AttachmentPath && (
               
                    <a
                    href={`http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/forecast/attachmentload/${h.ResponseID}`}
                      // href={`http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/forecast/attachment/${historyItem.ForecastID}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      ดาวน์โหลดไฟล์แนบ
                    </a>
                  )} */}
                  <hr />
                </div>
              ))
            )}
          </div>
        </div>
      )}

      {showResponseDialog && selectedForecast && (
        <div className="dialog-overlay">
          <div className="dialog-box">
            <button
              className="close-btn"
              onClick={() => setShowResponseDialog(false)}
            >
              X
            </button>

            <h2>Replies Forecast {selectedForecast.YearMonth}</h2>

            <label className="response-label">
              Supplier Response:
              <select
                className={`response-select ${
                  status === "Confirmed"
                    ? "status-confirmed"
                    : status === "Has Issue"
                      ? "status-rejected"
                      : ""
                }`}
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="Confirmed">Confirmed Forecast</option>
                <option value="Has Issue">Rejected Forecast</option>
              </select>
            </label>

            {status === "Has Issue" && (
              <>
                <label className="issue-label">
                  Report Issue:
                  <textarea
                    className="issue-textarea"
                    value={issueDetail}
                    onChange={(e) => setIssueDetail(e.target.value)}
                  />
                </label>

                <label>
                  Attach file:
                  <input
                    type="file"
                    onChange={(e) => setAttachment(e.target.files[0])}
                  />
                </label>
              </>
            )}

            <div className="dialog-actions">
              <button
                className="submit-btn"
                disabled={isSubmitting}
                onClick={async () => {
                  if (isSubmitting) return; // กันซ้ำอีกชั้น

                  try {
                    setIsSubmitting(true);
                    await handleSubmit();
                    setShowResponseDialog(false);
                  } finally {
                    setIsSubmitting(false);
                  }
                }}
              >
                {isSubmitting ? "Submitting..." : "Submit Response"}
              </button>
            </div>
          </div>
        </div>
      )}

      {previewUrl && previewItem && (
        <div className="preview-modal">
          <div className="preview-content">
            <div className="preview-header">
              <button className="close-btn" onClick={() => setPreviewUrl(null)}>
                X
              </button>

              {/* <div className="preview-actions">
                <button
                  className="confirm-btn"
                  onClick={() => {
                    setSelectedForecast(previewItem);
                    setShowResponseDialog(true);
                    setPreviewUrl(null); // ปิด preview
                  }}
                >
                  Forecast Confirmation
                </button>
              </div> */}
            </div>

            <iframe
              src={previewUrl}
              title="Forecast Preview"
              width="100%"
              height="100%"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Forecast;
